import { render, staticRenderFns } from "./motuo.vue?vue&type=template&id=4e8f91dd&"
import script from "./motuo.vue?vue&type=script&lang=js&"
export * from "./motuo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports